module.exports = __webpack_public_path__ + "static/media/weapon_dummy.7c8af4f5.svg";